<template>
  <div id="buttonrow" class="ml-0">
    <v-btn color="primary" id="export-png" @click="exportAllPng()" class="mx-1"
      >匯出所有圖表</v-btn
    >
    <!-- <v-btn color="primary" id="export-pdf" @click="exportAllPDF()" class="mx-1"
      >Export to PDF</v-btn
    > -->
  </div>
</template>

<script>
// import Highcharts from 'highcharts'
export default {
  data() {
    return {}
  },
  components: {},
  props: {},
  computed: {},
  methods: {
    exportAllPng() {
      var charts = new Array();
      var arr = this.$store.state.charts;
      for(var i = 0; i < arr.length; i++){
        charts.push(Highcharts.chart(arr[i].id, arr[i].option));
      }
      if (charts.length > 0) Highcharts.exportCharts(charts)
    },
    //   // 中文變亂碼issue
    // exportAllPDF() {
    //   var charts = new Array();
    //   var arr = this.$store.state.charts;
    //   for(var i = 0; i < arr.length; i++){
    //     charts.push(Highcharts.chart(arr[i].id, arr[i].option));
    //   }
    //   if (charts.length > 0) Highcharts.exportCharts(charts, { type: 'application/pdf' })
    // },
  },
  mounted() {
    /**
     * Create a global getSVG method that takes an array of charts as an argument. The SVG is returned as an argument in the callback.
     */
    Highcharts.getSVG = function (charts, options, callback) {
      var svgArr = [],
        top = 0,
        width = 0,
        addSVG = function (svgres) {
          // Grab width/height from exported chart
          var svgWidth = +svgres.match(/^<svg[^>]*width\s*=\s*\"?(\d+)\"?[^>]*>/)[1],
            svgHeight = +svgres.match(/^<svg[^>]*height\s*=\s*\"?(\d+)\"?[^>]*>/)[1],
            // Offset the position of this chart in the final SVG
            svg = svgres.replace('<svg', '<g transform="translate(0,' + top + ')" ')
          svg = svg.replace('</svg>', '</g>')
          top += svgHeight
          width = Math.max(width, svgWidth)
          svgArr.push(svg)
        },
        exportChart = function (i) {
          if (i === charts.length) {
            return callback(
              '<svg height="' +
                top +
                '" width="' +
                width +
                '" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
                svgArr.join('') +
                '</svg>'
            )
          }
          charts[i].getSVGForLocalExport(
            options,
            {},
            function () {
              console.log('Failed to get SVG')
            },
            function (svg) {
              addSVG(svg)
              return exportChart(i + 1) // Export next only when this SVG is received
            }
          )
        }
      exportChart(0)
    }

    /**
     * Create a global exportCharts method that takes an array of charts as an argument,
     * and exporting options as the second argument
     */
    Highcharts.exportCharts = function (charts, options) {
      options = Highcharts.merge(Highcharts.getOptions().exporting, options)

      // Get SVG asynchronously and then download the resulting SVG
      Highcharts.getSVG(charts, options, function (svg) {
        Highcharts.downloadSVGLocal(svg, options, function () {
          console.log('Failed to export on client side')
        })
      })
    }

    // Set global default options for all charts
    Highcharts.setOptions({
      exporting: {
        fallbackToExportServer: false, // Ensure the export happens on the client side or not at all
      },
    })

    // document.getElementById('export-png').addEventListener('click', () => {
    // Highcharts.exportCharts(this.$store.state.charts);
    // });

    //  document.getElementById('export-pdf').addEventListener('click', () => {
    //     Highcharts.exportCharts(this.$store.state.charts, {
    //         type: 'application/pdf'
    //     });
    // });
  },
}
</script>
